import React, { useState } from 'react';
import { KeyboardArrowDown, InfoOutlined, KeyboardArrowUp } from '@mui/icons-material';
import { Accordion, AccordionSummary, Stack, AccordionDetails, Typography } from '@mui/material';

const SHOW_DETAILS_TEXT = 'Schritt-für-Schritt-Anleitung einblenden';
const HIDE_DETAILS_TEXT = 'Anleitung ausblenden';

export const CustomCheckListAccordion = ({ Content, index }: { Content: React.ComponentType; index: number }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <Accordion
      expanded={expanded}
      sx={{
        '&.MuiAccordion-root,.MuiAccordion-root.Mui-expanded': {
          margin: 0,
          '&:before': { backgroundColor: 'grey.300', opacity: 1 },
        },
      }}
    >
      <AccordionSummary
        aria-controls={`panel${index}-content`}
        id={`panel${index}-header`}
        expandIcon={<KeyboardArrowDown sx={{ color: 'primary.main' }} />}
        onClick={toggleExpanded}
        sx={({ spacing }) => ({
          backgroundColor: 'grey.100',
          '&.MuiAccordionSummary-root': {
            padding: 5,
            borderRadius: `0 0 ${spacing(3)} ${spacing(3)}`,
            justifyContent: 'start',
          },
          '& .MuiAccordionSummary-content': {
            margin: 0,
            flexGrow: 0,
            '& .MuiStack-root': {
              '&:after': { content: `'${SHOW_DETAILS_TEXT}'` },
            },
            '&.Mui-expanded': {
              margin: 0,
              '& .MuiStack-root': { '&:after': { content: `'${HIDE_DETAILS_TEXT}'` } },
            },
          },
          '&.Mui-expanded': { borderRadius: 0 },
        })}
      >
        <Stack direction="row" alignItems="center" color="primary.main">
          <InfoOutlined sx={{ mr: 2, color: 'primary.main' }} />
        </Stack>
      </AccordionSummary>
      <AccordionDetails
        sx={({ spacing }) => ({
          backgroundColor: 'grey.100',
          px: 5,
          py: 0,
          borderRadius: `0 0 ${spacing(3)} ${spacing(3)}`,

          '& > *': {
            borderTop: '1px solid',
            borderColor: 'grey.300',
            py: 5,
          },
        })}
      >
        <Content />
        <Stack direction="row" onClick={toggleExpanded} sx={{ cursor: 'pointer' }}>
          <InfoOutlined sx={{ mr: 2, color: 'primary.main' }} />
          <Typography color="primary.main" variant="body1" lineHeight="22px">
            {HIDE_DETAILS_TEXT}
          </Typography>
          <KeyboardArrowUp sx={{ color: 'primary.main' }} />
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
